module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Acknowledgements"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_List_of_Abbreviations"
    }
  }, [_c('i', [_vm._v("List of Abbreviations")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Foreword"
    }
  }, [_c('i', [_vm._v("Foreword")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01"
    }
  }, [_c('b', [_vm._v("Chapter 1")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01"
    }
  }, [_vm._v("General Sir Ian Hamilton and the British Army, 1853–1915")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 2")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why Gallipoli?")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 3")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Badly Launched Operation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 4")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fighting and Command")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 5")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Command and Politics")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 6")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fighting and the Truth")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 7")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Unfair Withdrawal?")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 8")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06ac474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 66
// module chunks = 0